import { Product } from '../types';

export const generateProductSchema = (product: Product) => {
  const description = (product.full_description || product.name).replace(/<[^>]+>/g, '').slice(0, 5000);

  const rawImages = Array.isArray(product.image_url)
    ? product.image_url
    : (product.image_url ? [product.image_url] : []);
  const images = rawImages
    .map((img: any) => (typeof img === 'string' ? img : (img?.url || '')))
    .filter(Boolean);

  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "image": images.length > 0 ? images : undefined,
    "description": description,
    "sku": product.id || product.slug,
    "brand": {
      "@type": "Brand",
      "name": "AstroJi"
    },
    "offers": {
      "@type": "Offer",
      "url": `https://astroji.com/product/${encodeURIComponent(product.slug)}`,
      "priceCurrency": "INR",
      "price": Number(product.price) || 0,
      "priceValidUntil": "2026-12-31",
      "availability": product.isVisible ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "itemCondition": "https://schema.org/NewCondition",
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "IN"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 2,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 3,
            "maxValue": 7,
            "unitCode": "DAY"
          }
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "IN",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 7,
        "returnMethod": "https://schema.org/ReturnByMail",
        "returnFees": "https://schema.org/FreeReturn"
      },
      "seller": {
        "@type": "Organization",
        "name": "AstroJi"
      }
    },
    ...(product.review_count && product.review_count > 0 && product.rating && product.rating > 0 ? {
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": product.rating,
        "reviewCount": product.review_count
      }
    } : {})
  };
};

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AstroJi",
    "url": "https://astroji.com",
    "logo": "https://astroji.com/astroji-logo.png",
    "description": "Authentic Spiritual, Astrological & Wellness Products carefully curated for peace, prosperity, and positivity.",
    "sameAs": [
      "https://www.facebook.com/astroji",
      "https://www.instagram.com/astroji.official"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["en", "hi"]
    }
  };
};

export const generateWebSiteSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "AstroJi",
    "url": "https://astroji.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://astroji.com/products?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };
};

export const generateBreadcrumbSchema = (items: { name: string; item: string }[]) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.item
    }))
  };
};
